<template>
  <div>
    <!-- <v-select
      v-model="actualPrinter"
      :options="printers"
      class="margin-multi sp-border-input bg-white w-25 mb-2"
      placeholder="Impresora"
    /> -->
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold flex-column  flex-sm-row padding-sm d-flex justify-content-between catalogo-text"
          >
            <!-- <span class="sp-margin-b"> -->
            Catálogo de actividades
            <!-- </span> -->
            <!-- <div class="d-flex  sp-center flex-wrap"> -->
            <!-- <router-link
                class="sp-margin-b"
                :to="{ name: 'ActividadesCostos' }"
              >
                <CButton color="primary" class="mr-1 sp-width-butom px-1">
                  <CIcon class="mr-1" name="cil-book" />Actividades Costos
                </CButton>
              </router-link> -->
            <router-link :to="{ name: 'NuevoActividad' }">
              <CButton color="primary" class="mr-1 mt-2 mt-sm-0 sp-width-butom">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Actividad
              </CButton>
            </router-link>
            <!-- <div class="sp-margin-b">
                <CButton
                  @click="selectAll()"
                  color="primary"
                  class="mr-1 sp-width-butom  d-flex "
                >
                  <CIcon class="mr-1" name="cil-check" />Seleccionar Todos
                </CButton>
              </div> -->
            <!-- <div class="sp-margin-b">
                <CButton
                  @click="printModal = true"
                  color="primary"
                  class="mr-1 sp-width-butom  d-flex "
                >
                  <CIcon class="mr-1" name="cil-barcode" />Imprimir Series
                </CButton>
              </div> -->
            <!-- <div class="sp-margin-b">
                <CButton
                  @click="printModalNanoid = true"
                  color="primary"
                  class="mr-1 sp-width-butom  d-flex "
                >
                  <CIcon class="mr-1" name="cil-barcode" />Imprimir Codigos
                </CButton>
              </div> -->
            <!-- </div> -->
          </CCardHeader>
          <CCardBody>
            <!-- <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoading"
            >
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div> -->

            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="filteredItems"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
              pagination
            >
              <template #over-table>
                <CRow>
                  <CCol sm="11" col="10">
                    <CInput
                      v-model="filter"
                      placeholder="Búsqueda por actividad..."
                    />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-print" />
                        </CButton>
                      </template>

                      <CDropdownItem
                        @click="onClickPrintSeries"
                        class="no-padding"
                      >
                        <div class="custom-padding">
                          <CIcon class="mr-1" name="cil-print" />Imprimir Series
                        </div>
                      </CDropdownItem>
                      <CDropdownItem
                        @click="onClickPrintCodes"
                        class="no-padding"
                      >
                        <div class="custom-padding">
                          <CIcon class="mr-1" name="cil-print" />Imprimir
                          Codigos
                        </div>
                      </CDropdownItem>
                    </CDropdown>
                  </CCol>
                </CRow>
              </template>
              <template #check-header>
                <div class="text-center" @click="selectAll()">
                  <CIcon v-if="allSelections" name="cil-x-circle" />
                  <CIcon v-else name="cil-check" />
                </div>
              </template>
              <template #nombre="{item, index}">
                <td v-if="filter" class="py-2">{{ item.payload.nombre }}</td>
                <td
                  v-else
                  :class="
                    `${
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? `cursor-p`
                        : ``
                    }`
                  "
                  class="py-2"
                  @click="toggleUbicaciones(index)"
                >
                  <span>
                    <CIcon
                      v-if="
                        items.filter(
                          hijo => hijo.payload.pertenece_id == item.id
                        ).length > 0
                      "
                      name="cil-chevron-circle-down-alt"
                    />
                  </span>
                  {{ item.payload.nombre }}
                </td>
              </template>
              <template #tipo_pago="{item, index}">
                <td v-if="filter" class="py-2">{{ item.payload.tipo_pago }}</td>
                <td
                  v-else
                  :class="
                    `${
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? `cursor-p`
                        : ``
                    }`
                  "
                  class="py-2"
                  @click="toggleUbicaciones(index)"
                >
                  {{ item.payload.tipo_pago }}
                </td>
              </template>
              <template #multiplicador="{item, index}">
                <td v-if="filter" class="py-2">
                  {{ item.payload.multiplicador_pago }}
                </td>
                <td
                  v-else
                  :class="
                    `${
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? `cursor-p`
                        : ``
                    }`
                  "
                  class="py-2"
                  @click="toggleUbicaciones(index)"
                >
                  {{ item.payload.multiplicador_pago }}
                </td>
              </template>
              <template #unidad="{item, index}">
                <td v-if="filter" class="py-2">{{ item.payload.unidad }}</td>
                <td
                  v-else
                  :class="
                    `${
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? `cursor-p`
                        : ``
                    }`
                  "
                  class="py-2"
                  @click="toggleUbicaciones(index)"
                >
                  {{ item.payload.unidad }}
                </td>
              </template>
              <template #check="{item}">
                <td class="py-2 px-0 custom-control custom-checkbox">
                  <p-check
                    class="p-svg p-curve"
                    name="check"
                    color="success"
                    v-model="item.selected"
                  >
                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                      <path
                        d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                        style="stroke: white;fill:white"
                      />
                    </svg>
                    Imprimir
                  </p-check>
                </td>
              </template>
              <template #edit="{item, index}">
                <td class="py-2">
                  <router-link
                    :to="{ name: 'EditarActividad', params: { id: item.id } }"
                  >
                    <CButton
                      color="success"
                      square
                      size="sm"
                      @click="toggleEdit(index, item)"
                      >Editar</CButton
                    >
                  </router-link>
                </td>
              </template>
              <template #space="{item,index}">
                <td class="py-2">
                  <CButton
                    :disabled="
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? true
                        : false
                    "
                    color="danger"
                    square
                    @click="toggleCancel(index, item)"
                    size="sm"
                    >Borrar</CButton
                  >
                </td>
              </template>
              <template v-if="!filter" #details="{item, index}">
                <CCollapse :show="details.includes(index)">
                  <table-collapse-activities
                    @click-cancel="toggleCancel"
                    @click-print="printNanoid"
                    :actividadPadre="item.id"
                    :actividades="
                      items.filter(hijo => hijo.payload.raiz_id == item.id).sort((a,b)=>a.payload.nombre.localeCompare(b.payload.nombre))
                    "
                  ></table-collapse-activities>
                </CCollapse>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Actividad"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas borrar la actividad {{ this.itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Imprimir Series</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deleteActividad(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>
    <CModal
      :show.sync="printModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Imprimir Series"
      color="info"
    >
      <label>Impresora</label>
      <v-select
        v-model="actualPrinter"
        :options="printers"
        class="margin-multi sp-border-input bg-white  mb-2"
        placeholder="Impresora"
      />
      <CInput
        label="Cantidad de series"
        v-model="itemModalPrint.cantidadSeries"
        placeholder="Cantidad de series"
        type="number"
      ></CInput>
      <CInput
        label="Cantidad de impresiones"
        v-model="itemModalPrint.cantidadCopias"
        placeholder="Cantidad de impresiones"
        type="number"
      ></CInput>
      <template #header>
        <h5 class="modal-title">Imprimir Series</h5>
        <CButtonClose @click="printModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="printModal = false" color="danger">Cancelar</CButton>
        <CButton @click="generateSeries()" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="printModalNanoid"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Imprimir Actividades"
      color="info"
    >
      <label>Impresora</label>
      <v-select
        v-model="actualPrinter"
        :options="printers"
        class="margin-multi sp-border-input bg-white  mb-2"
        placeholder="Impresora"
      />
      <CInput
        label="Cantidad de impresiones"
        v-model="itemModalPrintNanoid.cantidadCopias"
        placeholder="Cantidad de impresiones"
        type="number"
      ></CInput>

      <template #header>
        <h5 class="modal-title">Imprimir Actividades</h5>
        <CButtonClose @click="printModalNanoid = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="printModalNanoid = false" color="danger"
          >Cancelar</CButton
        >
        <CButton @click="printItems()" color="success">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import TableCollapseActivities from "../../customComponents/TableCollapseActivities";
import { customAlphabet } from "nanoid";
import PrettyCheck from "pretty-checkbox-vue/check";

const fields = [
  { key: "nombre", label: "Nombre", _style: "width:25%" },
  { key: "tipo_pago", label: "Tipo de pago", _style: "width:25%" },
  { key: "multiplicador", label: "Multiplicador", _style: "width:25%" },
  { key: "unidad", label: "Unidad", _style: "width:25%" },
  {
    key: "check",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "space",
    label: "",
    _style: "width: 1%",
    sorter: false,
    filter: false
  }
  // ,
  // {
  //   key: "cancel",
  //   label: "",
  //   _style: "width:1%",
  //   sorter: false,
  //   filter: false
  // }
];

export default {
  name: "Actividades",

  components: {
    TableCollapseActivities,
    vSelect,
    "p-check": PrettyCheck
  },

  data() {
    return {
      items: [],
      fields,
      filter: "",
      dropdownCustom: false,
      cancelModal: false,
      printModal: false,
      printModalNanoid: false,
      details: [],
      allSelections: false,
      itemModal: { id: "", name: "", index: "" },
      itemModalPrint: { cantidadSeries: 1, cantidadCopias: 1 },
      itemModalPrintNanoid: { cantidadCopias: 1 },
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      isLoading: false
    };
  },

  created() {
    window.printSetup();
    this.isLoading = true;
    this.$store
      .dispatch("customHTTP", { schema: "actividades" })
      .then(res => {
        this.items = res.data
          ? res.data.map(act => {
              return { ...act, selected: false };
            }).sort((a,b)=>a.payload.nombre.localeCompare(b.payload.nombre))
          : [];
        // res.data.forEach(ubicacion => {
        //   if (ubicacion.payload.pertenece_id == 0) {
        //     this.items.push(ubicacion);
        //   } else {
        //     this.itemsHijos.push(ubicacion);
        //   }
        // });
      })
      .finally(() => (this.isLoading = false));
  },

  computed: {
    printers() {
      // console.log(window.printersDetected);

      return window.printersDetected();
    },
    actualPrinter() {
      return window.printerAct();
      // ? { value: window.printerAct.uid, label: window.printerAct.name }
      // : null;
    },
    filteredItems() {
      if (this.filter) {
        return (
          this.items
            //  .filter(i => i.payload.pertenece_id == 0)
            .filter(
              i =>
                `${i.payload.nombre}`
                  .toLowerCase()
                  .includes(this.filter.toLowerCase())||
                `${i.payload.unidad}`
                  .toLowerCase()
                  .includes(this.filter.toLowerCase()) ||
                `${i.payload.tipo_pago}`
                  .toLowerCase()
                  .includes(this.filter.toLowerCase()) ||
                `${i.payload.multiplicador_pago}`
                  .toLowerCase()
                  .includes(this.filter.toLowerCase())
            )
        );
      } else {
        return this.items.filter(i => i.payload.pertenece_id == 0);
        //  .filter(
        //    i =>
        //      i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
        //  );
        // ||
        // i.payload.unidad.toLowerCase().includes(this.filter.toLowerCase()) ||
        // i.payload.tipo_pago
        //   .toLowerCase()
        //   .includes(this.filter.toLowerCase()) ||
        // i.payload.multiplicador_pago
        //   .toLowerCase()
        //   .includes(this.filter.toLowerCase())
      }
    }
  },

  methods: {
    onClickPrintSeries() {
      this.printModal = true;
      this.closeDropdown();
    },
    onClickPrintCodes() {
      this.printModalNanoid = true;
      this.closeDropdown();
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    selectAll() {
      if (this.allSelections) {
        this.items = this.items
          ? this.items.map(act => {
              return { ...act, selected: false };
            }).sort((a,b)=>a.payload.nombre.localeCompare(b.payload.nombre))
          : [];
        this.allSelections = false;
      } else {
        this.items = this.items
          ? this.items.map(act => {
              return { ...act, selected: true };
            }).sort((a,b)=>a.payload.nombre.localeCompare(b.payload.nombre))
          : [];
        this.allSelections = true;
      }
    },
    printItems() {
      const idsToPrint = this.items.filter(item => item.selected === true);
      // console.log(idsToPrint);
      idsToPrint.length
        ? idsToPrint.map(actividad => {
            this.printNanoid(
              actividad,
              this.itemModalPrintNanoid.cantidadCopias
            );
          })
        : null;
    },
    generateSeries() {
      if (
        this.itemModalPrint.cantidadSeries &&
        this.itemModalPrint.cantidadSeries > 0
      ) {
        for (
          let index = 0;
          index < this.itemModalPrint.cantidadSeries;
          index++
        ) {
          const nanoid = customAlphabet(
            "1234567890abcdefghijklmnopqrstuvwxyz",
            7
          );
          const serie = `S${nanoid()}`;
          console.log(serie);

          //  if (this.actualPrinter) {
          this.printSerie(serie, this.itemModalPrint.cantidadCopias);
          //  }
        }
      }

      this.printModal = false;
    },
    printNanoid(actividad, cant) {
      if (actividad && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${actividad.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${actividad.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    printSerie(serie, cant) {
      if (serie && cant && cant > 0) {
        window.printTicket(
          `^XA^FO20,20^BY3^BCN,100,Y,N, ^FD${serie}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    toggleEdit(index, item) {
      this.modal = true;
      const itemIndex = {
        id: index,
        name: item.nombre
      };
      this.itemModal = itemIndex;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: this.items.indexOf(item)
      };
      this.itemModal = itemIndex;
    },
    toggleUbicaciones(index) {
      const position = this.details.indexOf(index);
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(index);
    },
    deleteActividad(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "actividades",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.z-custom {
  z-index: 1040;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 25%;
}
.custom-width5 {
  width: 10% !important;
}
.sp-border-input {
  border-radius: 4px;
}
.sp-flex {
  flex-direction: row;
}
.sp-margin-b {
  margin-bottom: 0;
}
.sp-width-butom {
  width: 160px;
}
.sp-center {
  justify-content: space-between;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 1400px) {
  .sp-flex {
    flex-direction: column;
  }
  .sp-margin-b {
    margin-bottom: 0.8rem;
  }
}
@media (max-width: 400px) {
  .sp-center {
    justify-content: center;
  }
}
</style>
